// extracted by mini-css-extract-plugin
export default {"content":"RoomsceneSwitcher_content__kDGVs","scenes":"RoomsceneSwitcher_scenes__rq9Uq"};